import { Flex } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import { Tooltip } from '@material-ui/core';
import MenuButton, { MenuButtonItem } from 'components/MenuButton';
import useUserActionsData from '../hooks/useUserActionsData';
import DisabledMenu from './DisabledMenu';
import useScimSetting from 'common/hooks/settings/useScimSetting';
import { LBButton } from '@linearb/buzz';

const UserActionButton = ({
  tooltipTitle,
  onClick,
  iconName,
  dataTestId = '',
  showIcon = false
}) => (
  <>
    {showIcon ? (
      <Tooltip title={tooltipTitle}>
        <LBButton
          variant='ghost'
          size='icon'
          onClick={onClick}
          data-testid={dataTestId}
        >
          <Icon name={iconName} size='normal' color='shuttleGray' />
        </LBButton>
      </Tooltip>
    ) : null}
  </>
);

const UserActions = ({
  myAccount,
  toggleSnackBar,
  resendInvitation,
  destroyInvitation,
  destroyAccount,
  toggleModal,
  changeUserAccountType,
  changeInvitationAccountType,
  ssoForceAndOk,
  account = {},
  isRBACEnabled
}) => {
  const {
    canResend,
    canEditPermissions,
    canDelete,
    destroyRecord,
    onResendInvitation,
    changeUserRole,
    onEditPermissions
  } = useUserActionsData({
    myAccount,
    toggleSnackBar,
    resendInvitation,
    destroyInvitation,
    destroyAccount,
    toggleModal,
    changeUserAccountType,
    changeInvitationAccountType,
    ssoForceAndOk,
    account
  });
  const scimSetting = useScimSetting();
  const { isPending, id } = account;
  const shouldShowMenuButton = canResend || canEditPermissions || canDelete;

  if (scimSetting.isEnabled)
    return <DisabledMenu tooltip={scimSetting.disabledTooltip} />;

  return isRBACEnabled ? (
    myAccount.id !== id && shouldShowMenuButton && (
      <Flex width='100%' borderBox justify='flex-end' pr='1rem'>
        <MenuButton
          items={[
            canResend && (
              <MenuButtonItem
                key='resend-invitation'
                text='Resend Invitation'
                icon={<Icon name='Send' color='shark' />}
                onClick={onResendInvitation}
              />
            ),
            canEditPermissions && (
              <MenuButtonItem
                key='edit-permissions'
                text='Edit Permissions'
                icon={<Icon name='usereditmerge' color='shark' />}
                onClick={onEditPermissions}
              />
            ),
            canDelete && (
              <MenuButtonItem
                key='delete'
                text={`Delete ${isPending ? 'invitation' : 'User'}`}
                icon={<Icon name='userremove' color='shark' />}
                onClick={destroyRecord}
              />
            )
          ].filter(Boolean)}
        />
      </Flex>
    )
  ) : (
    <div className='flex flew-row items-center justify-end'>
      <UserActionButton
        tooltipTitle='Resend invitation'
        onClick={onResendInvitation}
        iconName='Send'
        dataTestId='resend-invitation-data-testid'
        showIcon={canResend}
      />
      <UserActionButton
        tooltipTitle='Change user role'
        onClick={changeUserRole}
        iconName='EditUser'
        dataTestId='change-user-role-data-testid'
        showIcon={canEditPermissions}
      />
      <UserActionButton
        tooltipTitle={`Delete ${isPending ? 'invitation' : 'account'}`}
        onClick={destroyRecord}
        iconName='Delete'
        dataTestId='delete-user-data-testid'
        showIcon={canDelete}
      />
    </div>
  );
};

export default UserActions;
